import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AboutIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.48346 14.2369C2.67081 14.2361 1.92258 13.813 1.52927 13.1316C1.13596 12.4503 1.15953 11.6182 1.59083 10.9583L5.61505 4.80302C6.02839 4.13279 6.78876 3.73021 7.601 3.75154C8.41324 3.77287 9.14944 4.21477 9.52383 4.90569C9.89822 5.59661 9.85184 6.42775 9.40269 7.07648L5.38086 13.2318C4.9718 13.858 4.25458 14.238 3.48346 14.2369Z",
                stroke: "#6161FF",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.84016 14.2369C9.02884 14.2361 8.28183 13.814 7.88916 13.1343C7.4965 12.4546 7.52003 11.6244 7.95063 10.9661L11.9671 4.82543C12.3739 4.14542 13.137 3.7332 13.9553 3.75131C14.7736 3.76941 15.516 4.21493 15.8896 4.9122C16.2632 5.60947 16.2081 6.44659 15.7461 7.09349L11.7297 13.2342C11.3222 13.8576 10.6083 14.2364 9.84016 14.2369V14.2369Z",
                stroke: "#6161FF",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5247 14.2495C17.7538 14.2495 18.7501 13.2549 18.7501 12.0279C18.7501 10.801 17.7538 9.8064 16.5247 9.8064C15.2957 9.8064 14.2993 10.801 14.2993 12.0279C14.2993 13.2549 15.2957 14.2495 16.5247 14.2495Z",
                stroke: "#6161FF",
                strokeWidth: "1.25"
            })
        ]
    });
